
import React from 'react';
import './AdminDashboard.scss';
import AdminHeader from './AdminHeader';
import { Link } from 'react-router-dom';

const AdminDashboard: React.FC = () => {
  return (
    <div className="admin-dashboard">
      <AdminHeader />
      <div className="admin-dashboard__content">
        <h1>Admin Panel</h1>
        <p>Welcome to your advanced admin dashboard. Use the sections below to manage your website.</p>
        <div className="admin-nav">
          <Link to="/admin/blogs" className="admin-nav-link">Blog Management</Link>
          <Link to="/admin/comments" className="admin-nav-link">Comment Management</Link>
          <Link to="/admin/seo" className="admin-nav-link">SEO Tools</Link>
          <Link to="/admin/analytics" className="admin-nav-link">Analytics & Performance</Link>
        </div>
        <div className="admin-info">
          <h2>Features</h2>
          <ul>
            <li>Post, edit, update, and delete blogs with a free content editor</li>
            <li>View total likes, views, and comments for each post</li>
            <li>Manage user comments: approve, reject, or delete</li>
            <li>Optimize SEO: title, meta description, keywords, Open Graph, schema markup</li>
            <li>Check website performance, visitors, and keyword rankings (Google & Bing)</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;

